import {createUseStyles} from "react-jss";
import { breakpoints } from "../../constants/breakpoints";
import { colors } from "../../constants/colors";

export const styles = createUseStyles(theme => ({
  nameWrapper: {
    display: "flex",
    minWidth: "100px",
  },
  planeIcon: {
    alignContent: "center",
    overflow: "visible !important"
  },
  initialsAvatar: {
    alignSelf: "center",
    width: "40px",
    height: "40px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "40px",
    "& span": {
      color: colors.mediumGrey
    }
  },
  details: {
    marginLeft: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& p": {
      margin: 0,
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "& p:first-child": {
      color: colors.lightBlack,
      fontWeight: "500",
      lineHeight: "20px",
    },
    "& p:last-child": {
      color: colors.mediumGrey,
      fontWeight: "400",
      lineHeight: "20px",
    }
  },
  dotsStyle:{
    display:"flex",
    alignItems:"center",
    cursor: "pointer",
    marginLeft: "-4px",
    "& path": {
      stroke: colors.inactiveGrey
    },
    "&:hover": {
      "& path": {
        stroke: colors.grey
      }
    },
    "&:focus": {
      "& path": {
        stroke: colors.grey
      }
    },
  },
  gridMobileWrapper: {
    marginBottom: "48px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "0px 32px",
      marginBottom: "32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "0px 16px",
      marginBottom: "16px",
    }
  },
  gridWrapper: {
    border: "1px solid " + colors.lightGrey,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
    borderRadius: "12px",
    "&.chevron": {
      "& .rdt_TableRow": {
        cursor: "pointer",
      }
    },
    "& .rdt_TableRow": {
      "& >div:last-child": {
        backgroundColor: "inherit"
      }
    },
    "& .rdt_TableCell:last-child": {
        paddingRight: "40px"
    },
  },
  popoverStyle:{
    border:"none",
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverDiv:{
    display:"flex",
    alignItems:"center",
    flexDirection:"column",
    backgroundColor: colors.white,
    padding: '10px 15px',
    width:"240px",
    border: "1px solid #EAECF0",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: colors.grey,
    cursor: "pointer",
  },
  row:{
    height:"38px",
    width:"228px",
    display:"flex",
    alignItems:"center",
    padding:"10px",
    fontWeight: 500,
    fontFamily: theme.fontFamily,
    "&:hover": {
      color: colors.grey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px"
    },
  },
  delete: {
    color: colors.darkRed,
    "&:hover": {
      color: colors.darkRed,
    },
  },
  actionsWrapper: {
    display: "flex",
    flexDirection: "row",
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.lightBlack
  },
  disabled: {
    pointerEvents: "none",
    color: colors.darkGrey,
  },
  arrowIcon: {
    width: "16px",
    height: "16px",
    margin: "0 4px 3px",
  },
  sortIcon: {
    display: 'flex',
    marginLeft: '4px',
    height: '12px!important',
    width: '12px!important',
    opacity: '1 !important',
  },
  actionDisable: {
    backgroundColor: `${colors.white} !important`,
    border: "none"
  },
  editSpinner: {
    margin: 0,
    left: "unset"
  },
  dotsOpenStyle: {
    "& path": {
      stroke: colors.grey
    }
  }
}));

export const gridStyles = {
  table: {
    style: {

    }
  },
  headRow: {
    style: {
      backgroundColor: colors.brightBlue,
      color: colors.mediumGrey,
      borderColor: colors.lightGrey,
      fontWeight: "500",
      fontSize: "12px",
      minHeight: "44px"
    }
  },
  rows: {
    style: {
      color: colors.mediumGrey,
      borderColor: colors.lightGrey + "! important",
      fontWeight: "400",
      fontSize: "14px",
      minHeight: '72px',
      "&:hover": {
        backgroundColor: colors.brightBlue
      }
    },
  },
  headCells: {
    style: {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
  },
  cells: {
    style: {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
  },
  skeletonHead: {
    //border: "1px solid " + colors.lightGrey,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  skeletonBody: {
    //border: "1px solid " + colors.lightGrey
  }
};
